import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {PagerStateService} from '../../../Services/pager-state.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbpaginationConfigService} from '../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-employee-type-list',
  templateUrl: './employee-type-list.component.html',
  styleUrls: ['./employee-type-list.component.css'],
  standalone: false
})
export class EmployeeTypeListComponent extends ListPageBase implements OnInit {
  vm: any = {
    title: $localize`:Employee Type List@@employeeTypeList:Employee Type List`,
    list: [],
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/payroll/employee-type-form',
  };

  isLoaded = false;
  pageSize: number;

  constructor(
    private localStorage: StorageService,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
    this.pageSize = this.appConfig.ListPageSize;
  }

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle(this.vm.title);
    this.vm.list = [];
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));


    this.loadData();
  }

  protected fetchPage(): void {
    this.loadData();
  }

  loadData() {
    this.tableDataService.getData('pr_employee_type').subscribe({
      next: (result: any) => {
        this.vm.list = Array.isArray(result) ? result : (result.Data ?? []);
        this.totalRecords = this.vm.list.length;
        this.paginate(false);
        this.vm.listInitiated = true;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast($localize`:Error loading employee types@@errorLoadingEmployeeTypes:Error loading employee types`);
      },
    });
  }

  onNavigate(id: string) {
    this.router.navigate([this.vm.formRoute], {queryParams: {id}}).then();
  }
}
